import React from 'react';

import styled from 'styled-components';

// TODO: fix onRemove???

const RecentSearch = ({ hit, baseUrl, onRemove, ...props }) => {
    return (
        <Link
            href={baseUrl + encodeURIComponent(hit.label)}
            title={`Search for &quot;${hit.label}&quot;`}
            {...props}
        >
            <ClockIcon /> {hit.label}{' '}
            <RemoveButton
                onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onRemove && onRemove(hit.id);
                }}
                aria-label="Remove"
            >
                <RemoveIcon />
            </RemoveButton>
        </Link>
    );
};

const Link = styled.a`
    display: flex;
    gap: 10px;
    align-items: center;
    text-decoration: none;
    color: #333;
    font-size: 14px;
    font-weight: normal;

    &:hover {
        color: #333;
    }
`;

const ClockIcon = styled.i.attrs({
    className: 'fa fa-clock-o',
})``;

const RemoveButton = styled.button`
    background: none;
    border: none;
    border-radius: 2px;
    padding: none;
    width: 32px;
    height: 32px;
    font-size: 1.25em;
    margin-left: auto !important;
    color: #777;

    &:hover {
        color: #333;
        background: #e5e5e5;
    }
`;

const RemoveIcon = styled.i.attrs({
    className: 'fa fa-trash-o',
})``;

export default RecentSearch;
